// extracted by mini-css-extract-plugin
export default {"login":"Zg8Pmwbq","_hidden":"uKhvCySn","desktop":"desktop","mobile":"mobile"};